module.exports = __webpack_public_path__ + "static/media/logo-a.6002fd7a.gif";